import { withStyles } from 'vopay';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import ResetPasswordForm, { ResetPasswordFormValues } from './ResetPasswordForm';
import useResetPortalPassword from '@/hooks/useApi/useResetPortalPassword';
import { useDataFetchIndicator } from '@/hooks';
import styles from '../Login.module.scss';

const cn = withStyles(styles);

// Landing page for the link in the partner reset email: /#/password-reset/<token>
export default function ResetPasswordPage() {
  const { t } = useTranslation('translations', { keyPrefix: 'Login.ResetPassword.Page' });
  const history = useHistory();
  const { PasswordToken } = useParams<{ PasswordToken: string }>();
  const { resetPassword } = useResetPortalPassword();
  const [errorMessage, setErrorMessage] = useState('');
  // Fullscreen, blocking: the token is single-use, so a double submit must be impossible.
  const [, setBlocking] = useDataFetchIndicator();

  async function handleSubmit(values: ResetPasswordFormValues) {
    try {
      setBlocking(true);
      await resetPassword({ Password: values.Password, PasswordToken });
      history.push('/');
    } catch (error) {
      // The hook already logged; the backend's reason (expired/used link, weak password) is
      // shown inline under the field, where the user is looking. A blank reason still needs
      // a visible failure, so fall back to a generic one.
      const reason = error instanceof Error ? error.message : '';

      setErrorMessage(
        reason || t('genericError', { defaultValue: 'Could not reset your password. Please request a new link.' }),
      );
    } finally {
      setBlocking(false);
    }
  }

  // Same wrapper as Login so the card's Inter font and input sizing apply on this route too.
  return (
    <div className={cn('loginContainerInner')}>
      <ResetPasswordForm onSubmit={handleSubmit} errorMessage={errorMessage} />
    </div>
  );
}
